import { useParams } from 'react-router-dom';

import { PrepareIosPackagePage } from '~/components/pages/PrepareIosPackagePage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const PrepareIosPackageRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <PrepareIosPackagePage appId={appId} />
    </DashboardTemplate>
  );
};
